var map = {
	"./ion-action-sheet.entry.js": [
		640,
		29
	],
	"./ion-alert.entry.js": [
		641,
		30
	],
	"./ion-app_8.entry.js": [
		642,
		36
	],
	"./ion-avatar_3.entry.js": [
		643,
		50
	],
	"./ion-back-button.entry.js": [
		644,
		51
	],
	"./ion-backdrop.entry.js": [
		645,
		80
	],
	"./ion-button_2.entry.js": [
		646,
		52
	],
	"./ion-card_5.entry.js": [
		647,
		53
	],
	"./ion-checkbox.entry.js": [
		648,
		54
	],
	"./ion-chip.entry.js": [
		649,
		55
	],
	"./ion-col_3.entry.js": [
		650,
		81
	],
	"./ion-datetime_3.entry.js": [
		651,
		39
	],
	"./ion-fab_3.entry.js": [
		652,
		56
	],
	"./ion-img.entry.js": [
		653,
		82
	],
	"./ion-infinite-scroll_2.entry.js": [
		654,
		83
	],
	"./ion-input.entry.js": [
		655,
		57
	],
	"./ion-item-option_3.entry.js": [
		656,
		58
	],
	"./ion-item_8.entry.js": [
		657,
		59
	],
	"./ion-loading.entry.js": [
		658,
		60
	],
	"./ion-menu_3.entry.js": [
		659,
		61
	],
	"./ion-modal.entry.js": [
		660,
		37
	],
	"./ion-nav_2.entry.js": [
		661,
		47
	],
	"./ion-popover.entry.js": [
		662,
		38
	],
	"./ion-progress-bar.entry.js": [
		663,
		62
	],
	"./ion-radio_2.entry.js": [
		664,
		63
	],
	"./ion-range.entry.js": [
		665,
		64
	],
	"./ion-refresher_2.entry.js": [
		666,
		40
	],
	"./ion-reorder_2.entry.js": [
		667,
		49
	],
	"./ion-ripple-effect.entry.js": [
		668,
		84
	],
	"./ion-route_4.entry.js": [
		669,
		65
	],
	"./ion-searchbar.entry.js": [
		670,
		66
	],
	"./ion-segment_2.entry.js": [
		671,
		67
	],
	"./ion-select_3.entry.js": [
		672,
		68
	],
	"./ion-slide_2.entry.js": [
		673,
		85
	],
	"./ion-spinner.entry.js": [
		674,
		42
	],
	"./ion-split-pane.entry.js": [
		675,
		86
	],
	"./ion-tab-bar_2.entry.js": [
		676,
		69
	],
	"./ion-tab_2.entry.js": [
		677,
		48
	],
	"./ion-text.entry.js": [
		678,
		70
	],
	"./ion-textarea.entry.js": [
		679,
		71
	],
	"./ion-toast.entry.js": [
		680,
		72
	],
	"./ion-toggle.entry.js": [
		681,
		41
	],
	"./ion-virtual-scroll.entry.js": [
		682,
		87
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 419;
module.exports = webpackAsyncContext;